/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import FeaturedItemsModal from './FeaturedItemsModal';

const FeaturedItems = ({ lotList, coverPhotoList, catalogID }) => {
  const [showSelectModal, setShowSelectModal] = useState(false);
  const [featuredLots, setFeaturedLots] = useState([]);
  const [featuredIdList, setFeaturedIdList] = useState([]);
  const [hasFeaturedLots, setHasFeaturedLots] = useState(false);
  const [refreshData, setRefreshData] = useState(true);

  let itemsWithImages = false;
  const itemsArray = [];
  lotList.forEach(item => {
    if (item.images > 0 && item.lotNumber !== '') {
      itemsWithImages = true;
      const itemObject = {};
      itemObject.id = item.lotID;
      itemObject.lotExt = item.lotExt;
      itemObject.lotNumber = item.lotNumber;
      itemObject.comboNum = `${item.lotNumber}${item.lotExt}`;
      itemObject.title = item.lotTitle;
      itemObject.url = coverPhotoList[`${item.lotNumber}${item.lotExt}`];
      itemObject.banned = item.banned;
      itemsArray.push(itemObject);
    }
  });

  const handleSelectItemsClick = () => {
    setShowSelectModal(true);
  };

  const handleCloseModalClick = () => {
    setShowSelectModal(false);
  };

  useEffect(() => {
    const getFeaturedData = async () => {
      setHasFeaturedLots(false);
      try {
        const url = `/cps/app/featuredLots/catalog/${catalogID}`;
        const apiData = await axios(url);
        const featured = apiData.data.data.featuredLots;
        setFeaturedIdList(featured);

        if (featured.length > 0) {
          const featuredArray = itemsArray.filter(item => featured.indexOf(Number(item.id)) > -1);
          setFeaturedLots(featuredArray);
          setHasFeaturedLots(true);
        }
      } catch (error) {
        console.log('fetch api error');
      }
    };
    if (refreshData) {
      getFeaturedData();
    }
  }, [refreshData]);

  if (!itemsWithImages) {
    return null;
  }

  return (
    <div className="mt-4 mb-4">
      <div>
        {!hasFeaturedLots && (
          <div className="float-left mr-2 mt-1 newButton">
            NEW!
          </div>
        )}
        <div className="float-left">
          <div className="font-weight-bold">
            Featured Items
            {hasFeaturedLots && (
              <button type="button" className="btn btn-link" onClick={handleSelectItemsClick}>
                <FontAwesomeIcon icon="edit" className="ml-2 btn-link" />
              </button>
            )}
          </div>
          <div>
            Choose 5 items from your sale to highlight at the top of the catalog. If no items are selected, the auction will not display any featured lots.
          </div>
        </div>
        <div className="clear-both" />
      </div>
      {!hasFeaturedLots && (
        <div className="border mt-4 text-center featured-select-link">
          <button type="button" className="btn btn-link" onClick={handleSelectItemsClick}>
            <div>
              <FontAwesomeIcon className="color-blue fa-lg" icon="plus" />
            </div>
            <div className="mt-2 color-blue">
              Select Items
            </div>
          </button>
        </div>
      )}
      {hasFeaturedLots && (
        <>
          <div className="mt-3">
            {featuredLots.map(lot => (
              <div className="float-left mr-4" key={`featured_${lot.id}`}>
                <div className="border text-center featured-lot-image">
                  <img src={lot.url} alt={lot.title} />
                </div>
                <div className="mt-2 font-weight-bold">
                  Lot {lot.comboNum}:
                </div>
                <div className="featured-text-block">
                  {lot.title}
                </div>
              </div>
            ))}

          </div>
          <div className="clear-both" />
        </>
      )}

      <FeaturedItemsModal
        itemsArray={itemsArray}
        showSelectModal={showSelectModal}
        handleCloseModalClick={handleCloseModalClick}
        setShowSelectModal={setShowSelectModal}
        featuredIdList={featuredIdList}
        catalogID={catalogID}
        setRefreshData={setRefreshData}
      />
    </div>

  );
};

FeaturedItems.propTypes = {
  lotList: PropTypes.array.isRequired,
  coverPhotoList: PropTypes.object.isRequired,
  catalogID: PropTypes.number.isRequired,
};

export default FeaturedItems;
